export default {
    // Page titles and descriptions
    'referral.page.title': 'Referrals',
    'referral.page.description': 'Manage your referral program and track commissions',
    'referral.page.dashboard.title': 'Referral Dashboard',
    'referral.page.dashboard.description': 'Overview of your referral performance and statistics',
    'referral.page.referrals.title': 'My Referrals',
    'referral.page.referrals.description': 'View and manage all your referrals',
    'referral.page.commissions.title': 'Commission History',
    'referral.page.commissions.description': 'Track your commission earnings over time',
    'referral.page.payouts.title': 'Payout History',
    'referral.page.payouts.description': 'View your payout transactions and status',
    'referral.page.details.title': 'Referral Details',
    'referral.page.details.description': 'Detailed information about a specific referral',

    // Navigation
    'referral.nav.dashboard': 'Dashboard',
    'referral.nav.referrals': 'My Referrals',
    'referral.nav.commissions': 'Commissions',
    'referral.nav.payouts': 'Payouts',
    'referral.nav.back_to_list': 'Back to List',

    // Buttons
    'referral.button.view_details': 'View Details',
    'referral.button.export': 'Export',
    'referral.button.refresh': 'Refresh',
    'referral.button.filter': 'Filter',
    'referral.button.clear_filters': 'Clear Filters',

    // Stats cards
    'referral.stats.total_referrals': 'Total Referrals',
    'referral.stats.active_referrals': 'Active Referrals',
    'referral.stats.total_commissions': 'Total Commissions Earned',
    'referral.stats.pending_commissions': 'Pending Commissions',
    'referral.stats.total_payouts': 'Total Payouts Received',
    'referral.stats.pending_payouts': 'Pending Payouts',

    // Table headers
    'referral.table.referral_date': 'Referral Date',
    'referral.table.referred_tenant': 'Referred Customer',
    'referral.table.coupon_code': 'Coupon Code',
    'referral.table.commission_rate': 'Commission %',
    'referral.table.status': 'Status',
    'referral.table.total_commissions': 'Total Commissions',
    'referral.table.total_payouts': 'Total Payouts',
    'referral.table.pending_commissions': 'Pending Commissions',
    'referral.table.actions': 'Actions',
    'referral.table.commission_amount': 'Commission Amount',
    'referral.table.payment_date': 'Payment Date',
    'referral.table.payout_scheduled': 'Payout Scheduled',
    'referral.table.payout_amount': 'Payout Amount',
    'referral.table.payout_date': 'Payout Date',
    'referral.table.payment_method': 'Payment Method',
    'referral.table.transaction_id': 'Transaction ID',

    // Status labels
    'referral.status.active': 'Active',
    'referral.status.inactive': 'Inactive',
    'referral.status.pending': 'Pending',
    'referral.status.paid': 'Paid',
    'referral.status.reversed': 'Reversed',
    'referral.status.failed': 'Failed',

    // Filters
    'referral.filter.status': 'Status',
    'referral.filter.date_from': 'From Date',
    'referral.filter.date_to': 'To Date',
    'referral.filter.all_statuses': 'All Statuses',

    // Search and pagination
    'referral.search.placeholder': 'Search referrals...',
    'referral.pagination.showing': 'Showing {start} to {end} of {total} results',
    'referral.pagination.no_results': 'No referrals found',

    // Messages
    'referral.message.loading': 'Loading referral data...',
    'referral.message.error': 'Unable to load referral data. Please try again.',
    'referral.message.no_referrals': "You haven't made any referrals yet.",
    'referral.message.no_commissions': 'No commissions found.',
    'referral.message.no_payouts': 'No payouts found.',

    // Dashboard specific
    'referral.dashboard.recent_activity': 'Recent Activity',
    'referral.dashboard.upcoming_payouts': 'Upcoming Payouts',
    'referral.dashboard.performance': 'Performance Metrics',
    'referral.dashboard.monthly_trends': 'Monthly Trends',
    'referral.dashboard.conversion_rate': 'Conversion Rate',
    'referral.dashboard.avg_commission': 'Average Commission',

    // Details page
    'referral.details.overview': 'Overview',
    'referral.details.commission_history': 'Commission History',
    'referral.details.payout_history': 'Payout History',
    'referral.details.customer_info': 'Customer Information',
    'referral.details.referred_on': 'Referred On',
    'referral.details.customer_email': 'Customer Email',

    // Tooltips and help text
    'referral.help.commission_rate': 'The percentage of each payment you earn as commission',
    'referral.help.payout_delay': 'Payouts are processed 45 days after the payment date',
    'referral.help.minimum_payout': 'Minimum payout amount is $10.00',
    'referral.help.status_active': 'This referral is active and earning commissions',
    'referral.help.status_inactive': 'This referral is no longer earning commissions',

    // Success messages
    'referral.success.data_exported': 'Data successfully exported',
    'referral.success.filters_applied': 'Filters applied successfully',

    // Error messages
    'referral.error.export_failed': 'Export failed. Please try again.',
    'referral.error.invalid_date_range': 'Please select a valid date range',
    'referral.error.load_failed': 'Failed to load data. Please refresh the page.',
};
